<z-toast></z-toast>

@if (isLoading()) {
<div class="fixed inset-0 z-[9999] flex items-center justify-center bg-white/70 backdrop-blur-sm">
  <z-loader zSize="lg"></z-loader>
</div>
}

<router-outlet />